import React from 'react';
import { Link } from 'react-router-dom';   
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import ImportCSV from '../../../core/importCSV';
import {exportCSVFile} from '../../../core/CsvDownload';

const Url='/book-import'; 

const columName=[  // Database Column name
    'title',
    'isbn_no',
    'book_category_name',
    'access_number',
    'ddci_number',
    'author_name',
    'quantity',
    'purchase_date',
    'entry_date',
    'edition',
    'price',
    'pages',
    'publisher',
    'no_of_due_days_student',
    'no_of_due_days_staff',
    'publish_year',
    'rack_no'
];

const columnCSVTitle=[ {
    title:'Title',
    isbn_no:'ISBN Number',
    book_category_name:'Book Category Name',
    access_number:'Access Number',
    ddci_number:'DDCI Number',
    author_name:'Author Name',
    quantity:'Quantity',
    purchase_date:'Purchase Date',
    entry_date:'Entry Date',
    edition:'Edition',
    price:'Price',
    pages:'Pages',
    publisher:'Publisher',
    no_of_due_days_student:'No Of Due Days Student',
    no_of_due_days_staff:'No Of Due Days Staff',
    publish_year:'Publish Year',
    rack_no:'Rack No'
}
];


class BookImportCSV extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            data:[],
            errorData:[],
            preloader:this.props.match.params.id?true:false,
            pagetitle:this.props.match.params.id?'Edit':'New'
        };
    }
 
    submitForm=()=>{
        //if( this.validator.allValid() ){
        const {data,errorData} = this.state;
        console.log('length--->>>',data.length);
        //console.log(data);
        //return false; 
        if(data.length){
            let params={
                csvData:JSON.stringify(data)
            };
            //this.setState({preloader:true});
            processData(Url,params).then((res)=>{
                if(res.data.status===200){
                    //this.props.history.push(backUrl);

                    const rows=res.data.errorData.map((val,i)=>{
                        return{ 
                            title:val.title,
                            isbn_no:val.isbn_no,
                            book_category_name:val.book_category_name,
                            access_number:val.access_number,
                            ddci_number:val.ddci_number,
                            author_name:val.author_name,
                            quantity:val.quantity,
                            purchase_date:val.purchase_date,
                            entry_date:val.entry_date,
                            edition:val.edition,
                            price:val.price,
                            pages:val.pages,
                            publisher:val.publisher,
                            no_of_due_days_student:val.no_of_due_days_student,
                            no_of_due_days_staff:val.no_of_due_days_staff,
                            publish_year:val.publish_year,
                            rack_no:val.rack_no,
                        };
                    });
                    const headers=Object.assign({},columnCSVTitle);
                    rows.unshift(headers[0]); 
                    exportCSVFile(rows, 'duplicate-records');  
                    exportCSVFile(errorData, 'invalid-data');  
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';     alert(msg);
                    this.setState({preloader:false});
                }
            });
        } else {
            /* this.validator.showMessages();
            this.forceUpdate(); */
            alert('Please upload csv file');
        }  
    }
    getData=(data,errorData)=>{ 
        this.setState({data,errorData});
     
    }
    render() {
        const {preloader,status,pagetitle} = this.state;
        const role=permissionCheck('book',pagetitle);
        if(!role)
            return <Nopermission/>;
        return (
            <div id="page_content_inner"  className="uk-width-medium-6-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">Import Books CSV</h3>
                <div className="md-card">
                    <div className="md-card-content small-padding">
                        <div className="uk-grid"> 
                            <ImportCSV 
                                columName={columName}
                                getData={this.getData.bind()}
                                fileName="books"
                                columnCSVTitle={columnCSVTitle}
                            />
                        </div>
                         
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Import CSV</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default BookImportCSV;


// WEBPACK FOOTER //
// ./src/components/Library/Book/importBook.js